import { Icon } from './Icon';

/** The small trust pill in the app bar (forked from vCIP_droom_4.0). Label is always a translated string from the caller. */
export function SecurePill({ kind = 'secure', label }: { kind?: 'secure' | 'submitted'; label: string }): JSX.Element {
  return (
    <span className="secure-pill">
      <Icon name={kind === 'submitted' ? 'shield' : 'lock'} size={13} />
      {label}
    </span>
  );
}
